export default __webpack_public_path__ + "static/media/P306.0.1046ec52.mp3";